<template>
  
      <p class="tag" v-if="file" style="margin: 6px 6px 0 0;" :title="`${file.name}\n\n${tools.filesize(file.size)}`" >        
        <span v-if="icon"><img style="max-height: 16px; width: auto;" :src="icon"></span>
        <span v-if="!icon">📄</span>
        <span>{{ tools.cut(file.name, 15) }}</span>         
        <span class="tag delete" @click.prevent="$emit('delete',true)"></span> 
      </p>
      <!-- <p class="tag" v-upload="appendFiles">+Add files</p> -->
             
</template>
<script setup>
</script>
<script>
/* eslint-disable */
import { defineComponent } from 'vue';
export default defineComponent({
  mounted() {      
  //  
  },  
  props:{    
    file: undefined,
  },
  computed: {
    icon(){
      if (!this.file) return
      let ext = this.file.ext || this.tools.ext(this.file.link)
      if (!ext) {
        if (!this.file.name) return
        ext = this.tools.ext(this.file.name)
        if (!ext) return
      }
      if (!this.tools.fileicon(ext)) return
      ext = ext.toUpperCase()
      return `/images/icons/file/${ext}.svg`
    },
  },
  data() {
    return {    
     

    }
  },

  methods: {
    // deleteReply(){
    //   this.$emit("deleteReply",true)
    // }

    
  },
 
});

</script>
<style scoped>
.container{
   /* width: 380px;  */
   /* height: 100%;  */
   border-radius: 20px; 
   background-color: var(--g05);   
}
.messageBox{
  position: relative; 
  align-self: flex-end; 
  overflow-y: scroll; 
  width: 380px; 
  height: 100%; 
  transform: scale(1,-1); 
}
.messageList{
  padding: 15px; 
  padding-bottom: 60px; 
  transform: scale(1,1);
}
.inputBox{
  position: relative; 
  border-bottom-left-radius: 20px; 
  border-bottom-right-radius: 20px; 
  bottom: 0; 
  width: 100%;
  background-color: #1C1C1C;
}
</style>